import { FunctionComponent, SVGProps } from 'react';
import { CompanyApprovalStatus, CompanyRole } from 'tdc-web-backend/enums/enums';
import { ReactComponent as HomeLinkIcon } from '../../assets/icons/layout-icons/HomeLinkIcon.svg';
import { ReactComponent as SuitcaseCheckIcon } from '../../assets/icons/layout-icons/SuitcaseCheckIcon.svg';
import { ReactComponent as PieChartIcon } from '../../assets/icons/layout-icons/PieChartIcon.svg';
import { ReactComponent as JournalRichtextIcon } from '../../assets/icons/layout-icons/JournalRichtextIcon.svg';
import { ReactComponent as LifePreserverIcon } from '../../assets/icons/layout-icons/LifePreserverIcon.svg';
import { ReactComponent as Blogs } from '../../assets/icons/layout-icons/blogs.svg';
import { ReactComponent as RequestProject } from '../../assets/icons/project-icons/RequestProject.svg';
import { ReactComponent as TimedProject } from '../../assets/icons/project-icons/TimedProject.svg';
import { ReactComponent as StarIcon } from '../../assets/icons/star.svg';
import { ReactComponent as SettingsIcon } from '../../assets/icons/settings.svg';

export interface MenuItem {
  id?: number;
  title: string;
  to?: string;
  Icon: FunctionComponent<
    SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  name: string;
  children?: MenuItem[];
  disabled?: boolean;
  toolTip?: string;
}

export const dashboardMenuItemsBuyer = () => [
  {
    id: 1,
    title: 'sidebarMenu.home',
    to: '/dashboard',
    Icon: HomeLinkIcon,
    name: 'home',
  },
  {
    id: 2,
    title: 'common.tenders',
    to: './timed-projects',
    Icon: SuitcaseCheckIcon,
    name: 'timed-projects',
    disabled: false,
  },
  {
    id: 3,
    title: 'common.projects',
    to: './end-to-end',
    Icon: LifePreserverIcon,
    name: 'end-to-end',
    disabled: false,
  },
  {
    id: 4,
    title: 'common.settings',
    to: './settings/account',
    Icon: LifePreserverIcon,
    name: 'settings',
    disabled: false,
  },
  // {
  //   title: 'Insights',
  //   to: '/insights',
  //   Icon: PieChartIcon,
  //   name: 'insights',
  //   disabled: true,
  // },
];

export const dashboardMenuItemsSeller = (
  companyRoles: CompanyRole[],
  status: CompanyApprovalStatus
) => [
  {
    id: 0,
    title: 'sidebarMenu.home',
    to: '/dashboard',
    Icon: HomeLinkIcon,
    name: 'home',
  },
  // {
  //   title: 'Content',
  //   to: './content',
  //   Icon: JournalRichtextIcon,
  //   name: 'timed-projects',
  //   disabled: true,
  // },
  {
    id: 1,
    title: 'common.caseStudies',
    to: './case-studies/',
    Icon: JournalRichtextIcon,
    name: 'case-studies',
    disabled: status !== CompanyApprovalStatus.Approved,
    ...(status !== CompanyApprovalStatus.Approved && {
      toolTip: companyRoles.includes(CompanyRole.SellerService)
        ? 'postRegistration.yourProfileIsUnderReview'
        : 'postRegistration.completeYourCompanyProfile',
    }),
  },
  {
    id: 2,
    title: 'common.pitches',
    to: './pitches',
    Icon: SuitcaseCheckIcon,
    name: 'pitches',
    disabled: status !== CompanyApprovalStatus.Approved,
    ...(status !== CompanyApprovalStatus.Approved && {
      toolTip: companyRoles.includes(CompanyRole.SellerService)
        ? 'postRegistration.yourProfileIsUnderReview'
        : 'postRegistration.completeYourCompanyProfile',
    }),
  },
  {
    id: 3,
    title: 'common.projects',
    to: './end-to-end',
    Icon: LifePreserverIcon,
    name: 'end-to-end',
    disabled: false,
  },
  {
    id: 4,
    title: 'common.settings',
    to: './settings/account',
    Icon: SettingsIcon,
    name: 'settings',
    disabled: false,
  },
  // {
  //   title: 'Insights',
  //   to: '/insights',
  //   Icon: PieChartIcon,
  //   name: 'insights',
  //   disabled: true, // This is temp on true ether way
  // },
];

export const adminMenuItem: MenuItem[] = [
  {
    id: 1,
    title: 'Home',
    to: '../admin',
    Icon: HomeLinkIcon,
    name: 'home',
    disabled: true,
  },
  {
    id: 2,
    title: 'Projects (E2E)',
    to: '../admin/end-to-end/projects',
    Icon: SuitcaseCheckIcon,
    name: 'projects',
    disabled: false,
  },
  {
    id: 3,
    title: 'Requests (E2E)',
    to: '../admin/end-to-end/project-requests',
    Icon: SuitcaseCheckIcon,
    name: 'project-requests',
    disabled: false,
  },
  {
    id: 4,
    title: 'Payments',
    to: '../admin/end-to-end/payments',
    Icon: PieChartIcon,
    name: 'payments',
    disabled: false,
  },
  {
    id: 5,
    title: 'Seller (service)',
    to: '../admin/companies/sos',
    Icon: PieChartIcon,
    name: 'sos',
    disabled: false,
  },
  {
    id: 6,
    title: 'Seller (tool)',
    to: '../admin/companies/tos',
    Icon: PieChartIcon,
    name: 'tos',
    disabled: false,
  },
  {
    id: 7,
    title: 'Buyer',
    to: '../admin/companies/buyer',
    Icon: PieChartIcon,
    name: 'buyer',
    disabled: false,
  },
  {
    id: 8,
    title: 'Projects (Hire)',
    to: '../admin/timed-projects/',
    Icon: TimedProject,
    name: 'timed-projects',
    disabled: false,
  },
  {
    id: 9,
    title: 'Case study',
    to: '../admin/case-study/',
    Icon: RequestProject,
    name: 'case-study',
    disabled: false,
  },
  {
    id: 10,
    title: 'Study review',
    to: '../admin/case-study-review/',
    Icon: StarIcon,
    name: 'case-study-review',
    disabled: false,
  },
  {
    id: 11,
    title: 'Pitching',
    to: '../admin/pitching/',
    Icon: LifePreserverIcon,
    name: 'pitching',
    disabled: false,
  },
  {
    id: 12,
    title: 'Seller Archive',
    to: '../admin/seller-archive/',
    Icon: PieChartIcon,
    name: 'seller-archive',
    disabled: false,
  },
  {
    id: 13,
    title: 'C. Study Archive',
    to: '../admin/case-study-archive/',
    Icon: PieChartIcon,
    name: 'case-study-archive',
    disabled: false,
  },
  {
    id: 14,
    title: 'Footer seller',
    to: '../admin/footer/seller_archive',
    Icon: SuitcaseCheckIcon,
    name: 'footer-seller',
    disabled: false,
  },
  {
    id: 15,
    title: 'Footer c. study',
    to: '../admin/footer/case_study_archive',
    Icon: SuitcaseCheckIcon,
    name: 'footer-case-study',
    disabled: false,
  },
  {
    id: 16,
    title: 'Blog',
    to: '../admin/blogs',
    Icon: Blogs,
    name: 'blogs',
    disabled: false,
  },
  {
    id: 17,
    title: 'Featured Blogs',
    to: '../admin/featured-blogs',
    Icon: Blogs,
    name: 'featured-blogs',
    disabled: false,
  },
  {
    id: 18,
    title: 'Newsletter',
    to: '../admin/newsletter',
    Icon: Blogs,
    name: 'newsletter',
    disabled: false,
  },
];
